const core = await window.ArpineDS.importar("galeriaCore");

// Altura da coluna da galeria pro sticky do desktop (ds-product.css): mais alta que a janela, ela
// gruda pela base. Remede quando muda (miniaturas montadas, filtro por variante, largura da janela).
const colunaGaleria = document.querySelector(".ds-gallery")?.closest(".ds-pdp__galeria");
if (colunaGaleria) {
  new ResizeObserver(() => colunaGaleria.style.setProperty("--ds-galeria-h", `${colunaGaleria.offsetHeight}px`)).observe(colunaGaleria);
}

const gal = document.querySelector(".ds-gallery");

// Opções escolhidas agora, na ordem do produto (uma por fieldset do seletor). Lidas do documento a
// cada vez: o product-info troca o <variant-selects> inteiro a cada variante.
function escolhida() {
  const grupos = document.querySelectorAll("variant-selects .ds-opcao");
  if (!grupos.length) return null;
  return [...grupos].map((g) => g.querySelector(".ds-opcao__input:checked")?.value ?? "");
}

// Foto de variante: só a da combinação escolhida (regra em ds-galeria-core.js; o servidor já pintou
// a primeira vez). Escuta no documento, que sobrevive à troca do seletor; reage na hora do clique,
// sem esperar o product-info buscar a variante nova. Devolve true se mudou o que aparece.
let aoTrocar = () => {};
if (gal && gal.querySelector("[data-ds-variantes]")) {
  const itens = [...gal.querySelectorAll(".ds-gallery__item")];
  const combos = itens.map((li) => core.lerVariantes(li.dataset.dsVariantes));
  const aplicar = () => {
    const mostrar = core.visiveis(combos, escolhida());
    let mudou = false;
    itens.forEach((li, i) => {
      if (li.hidden === !mostrar[i]) return;
      li.hidden = !mostrar[i];
      mudou = true;
    });
    return mudou;
  };
  aplicar();
  document.addEventListener("change", (e) => {
    if (!e.target.closest?.("variant-selects .ds-opcao__input")) return;
    if (aplicar()) aoTrocar();
  });
}

// Carrossel: contador "1 / N", setas de clique (desktop), miniaturas pra pular direto e navegação
// por teclado. O contador conta só itens VISÍVEIS, porque o filtro por variante acima esconde alguns
// via [hidden] — a conta refaz a cada troca de variante que muda o que aparece.
if (gal) {
  const lista = gal.querySelector("[data-ds-gallery-lista]");
  const contador = gal.querySelector("[data-ds-gallery-contador]");
  const setas = [...gal.querySelectorAll("[data-ds-gallery-seta]")];
  const faixa = gal.querySelector("[data-ds-gallery-miniaturas]");

  if (lista && contador) {
    let observer = null;
    let observados = [];
    let atual = 0;

    const itensVisiveis = () => [...lista.querySelectorAll(".ds-gallery__item")].filter((li) => !li.hidden);

    function irPara(indice) {
      const alvo = observados[indice];
      if (alvo) alvo.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }

    function pintarEstado(indice) {
      const total = observados.length;
      atual = indice;
      contador.hidden = total <= 1;
      if (total > 1) contador.textContent = `${indice + 1} / ${total}`;
      for (const seta of setas) {
        seta.hidden = total <= 1;
        const passo = Number(seta.dataset.dsGallerySeta);
        seta.disabled = total <= 1 || (passo < 0 && indice === 0) || (passo > 0 && indice === total - 1);
      }
      if (faixa) {
        faixa.hidden = total <= 1;
        [...faixa.children].forEach((li, i) => {
          const botao = li.firstElementChild;
          if (botao) botao.setAttribute("aria-current", String(i === indice));
        });
        const ativa = faixa.children[indice];
        if (ativa) ativa.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
    }

    // Miniaturas nascem do próprio carrossel: clonam a <img> de cada item visível (o vídeo usa o
    // pôster), então não há uma segunda lista de fotos pra manter em sincronia no Liquid. Uma
    // miniatura por item SEMPRE, mesmo sem imagem: o índice dela é o índice do item.
    function montarMiniaturas() {
      if (!faixa) return;
      faixa.replaceChildren();
      if (observados.length <= 1) return;
      observados.forEach((item, i) => {
        const img = item.querySelector("img");
        const video = item.querySelector("video");
        const li = document.createElement("li");
        const botao = document.createElement("button");
        botao.type = "button";
        botao.className = "ds-gallery__mini";
        botao.setAttribute("aria-label", video ? `Ver vídeo (item ${i + 1})` : `Ver foto ${i + 1}`);
        const fonte = img ? img.currentSrc || img.src : video?.poster;
        if (fonte) {
          const mini = document.createElement("img");
          mini.src = fonte;
          mini.alt = "";
          mini.loading = "lazy";
          botao.append(mini);
        }
        botao.addEventListener("click", () => irPara(i));
        li.append(botao);
        faixa.append(li);
      });
    }

    function montarObserver() {
      if (observer) observer.disconnect();
      observados = itensVisiveis();
      montarMiniaturas();
      if (observados.length <= 1) {
        pintarEstado(0);
        return;
      }
      observer = new IntersectionObserver(
        (entradas) => {
          // O melhor da leva, não o último processado: várias entradas chegam juntas e só a de
          // maior visibilidade representa a foto que a pessoa está de fato vendo.
          let melhor = null;
          for (const entrada of entradas) {
            if (!entrada.isIntersecting || entrada.intersectionRatio < 0.6) continue;
            if (!melhor || entrada.intersectionRatio > melhor.intersectionRatio) melhor = entrada;
          }
          if (melhor) {
            const indice = observados.indexOf(melhor.target);
            if (indice >= 0) pintarEstado(indice);
          }
        },
        { root: lista, threshold: [0.6] }
      );
      for (const li of observados) observer.observe(li);
      pintarEstado(0);
    }

    montarObserver();
    // Trocou a variante e a capa mudou: volta pra 1ª foto, que é a capa nova.
    aoTrocar = () => {
      montarObserver();
      lista.scrollTo({ left: 0 });
    };

    for (const seta of setas) {
      seta.addEventListener("click", () => {
        const passo = Number(seta.dataset.dsGallerySeta);
        const destino = Math.min(Math.max(atual + passo, 0), observados.length - 1);
        irPara(destino);
      });
    }

    lista.addEventListener("keydown", (e) => {
      if (!["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"].includes(e.key)) return;
      e.preventDefault();
      const passo = e.key === "ArrowRight" || e.key === "ArrowDown" ? 1 : -1;
      irPara(Math.min(Math.max(atual + passo, 0), observados.length - 1));
    });
  }
}
